import React from 'react';
import styles from '../styles.module.css';
import classNames from 'classnames';

const ToolbarRow: React.FC<{ align?: string; children: React.ReactNode }> = ({
  children,
  align,
}) => {
  return (
    <div
      className={classNames(styles.toolbarRow, {
        [styles.toolbarRowAlignLeft]: align === 'left',
      })}
    >
      {children}
    </div>
  );
};

export default ToolbarRow;
